// axios
import axios from 'axios'

const baseURL = ''

const http = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    // Identifica a este front ante go-arpa-api. Es lo que hace que sus peticiones
    // entren en el registro de actividad (/activity-log) y las de las demás apps que
    // comparten esa API no: el middleware ActivityLogger solo registra `vendor`.
    //
    // OJO: el valor "vendor" NO está en la lista de prefijos de cookie de go-arpa-api
    // (helpers.clientAppPrefixes) y no debe estarlo. Añadirlo allí renombraría las
    // cookies de sesión de esta app a `vendor_access_token` y tiraría todas las
    // sesiones abiertas. Aquí la cabecera solo etiqueta el registro.
    'X-Client-App': 'vendor'
  }
})

// SegElevia apagado para la compañía (503 de go-arpa): las pantallas que enseñan error.message
// muestran «SegElevia no está disponible…» en vez de «Request failed with status code 503».
http.interceptors.response.use(response => response, error => {
  const response = error && error.response
  const message = response && response.data && response.data.error
  if (response && response.status === 503 && typeof message === 'string' && message.indexOf('SegElevia') !== -1) {
    error.message = message
  }
  return Promise.reject(error)
})

export default http
